export {
  FillFrameImage,
  FillFrameImageProps,
  DEFAULT_MAX_HEIGHT,
  DEFAULT_OBJECT_FIT,
  DEFAULT_RATIO,
} from "./FillFrameImage";
